export default __webpack_public_path__ + "images/f536e36dd606108ec62ea52102737fe4.svg";